import { render, staticRenderFns } from "./procurementPlanAction.vue?vue&type=template&id=5b3840fd&scoped=true"
import script from "./procurementPlanAction.vue?vue&type=script&lang=js"
export * from "./procurementPlanAction.vue?vue&type=script&lang=js"
import style0 from "./procurementPlanAction.vue?vue&type=style&index=0&id=5b3840fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3840fd",
  null
  
)

export default component.exports